module.exports = __webpack_public_path__ + "img/icon_empty.0da40a4b.svg";